import { Grid2 } from '@mui/material';
import TestimonialCard from '../../shared/components/TestimonialCard';
import HorizontalScroll from '../../shared/components/HorizontalScroll'


const TestimonialSection = ({ content }) => {
    const testimonials = ["#FFEEF2", "#EEF7FF", "#FBFFEE", "#FFF2E7", "#F1EEFF"];
    return (
        <>
            <HorizontalScroll heading={content?.data?.subheading} subheading={content?.data?.heading} size={1}>
                {/* {!isLoading && (
                    testimonial?.data?.elements?.map((item, index) => (
                        <Box key={index} sx={{ width: { xs: "600px", lg: "80%" }, flex: "0 0 auto" , display:"flex", alignItems:'stretch' }} >
                            <TestimonialCard item={item} bgColor={testimonials[index % testimonials.length]} />
                        </Box>
                    ))
                )} */}
                { (
                    content?.data?.testimonials?.map((item, index) => {
                        // Pick a random color from testimonials array
                        const randomBgColor = testimonials[Math.floor(Math.random() * testimonials.length)];
                        return (
                            <>
                                {item?.isShow &&
                                    <Grid2 key={index} size={{ xs: 12, lg: 9 }} sx={{ flex: "0 0 auto", display: "flex", alignItems: 'stretch' }}>
                                        <TestimonialCard item={item} bgColor={randomBgColor} />
                                    </Grid2>
                                }
                            </>

                        );
                    })
                )}
                
            </HorizontalScroll>
        </>
    )
}

export default TestimonialSection